var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKubigWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 116,
    viewBox: "0 0 295 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1585_10985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9368 10L44.1863 58.0766L67.7568 105.847H50.1239L27.2731 58.0766L50.4838 10H67.9368ZM10 105.847V10H26.1935V105.847H10Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.742 10H125.116V92.3732C125.116 101.356 119.478 105.847 108.203 105.847H88.2306C76.9552 105.847 71.3174 101.356 71.3174 92.3732V10H87.6909V90.2297C87.6909 92.067 88.0507 93.2919 88.7704 93.9043C89.4901 94.4147 90.9296 94.6698 93.0887 94.6698H103.345C105.624 94.6698 107.063 94.4147 107.663 93.9043C108.383 93.2919 108.742 92.067 108.742 90.2297V10Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.759 47.2057V25.311C175.759 23.4737 175.399 22.2998 174.679 21.7895C173.959 21.177 172.52 20.8708 170.361 20.8708H152.368V51.6459H170.361C172.52 51.6459 173.959 51.3907 174.679 50.8804C175.399 50.2679 175.759 49.0431 175.759 47.2057ZM175.759 90.5359V66.9569C175.759 65.1196 175.399 63.9458 174.679 63.4354C173.959 62.823 172.52 62.5167 170.361 62.5167H152.368V94.9761H170.361C172.52 94.9761 173.959 94.7209 174.679 94.2105C175.399 93.5981 175.759 92.3732 175.759 90.5359ZM136.174 10H175.219C186.494 10 192.132 14.4912 192.132 23.4737V47.8182C192.132 53.2281 189.733 56.3923 184.935 57.311C189.733 58.3317 192.132 61.2919 192.132 66.1914V92.3732C192.132 101.356 186.494 105.847 175.219 105.847H136.174V10Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.04 10H220.233V105.847H204.04V10Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 38.0191H268.627V25.311C268.627 23.4737 268.267 22.2998 267.547 21.7895C266.827 21.177 265.388 20.8708 263.229 20.8708H254.052C251.893 20.8708 250.454 21.177 249.734 21.7895C249.014 22.2998 248.655 23.4737 248.655 25.311V90.689C248.655 92.5263 249.014 93.7512 249.734 94.3636C250.454 94.874 251.893 95.1292 254.052 95.1292H263.229C265.388 95.1292 266.827 94.874 267.547 94.3636C268.267 93.7512 268.627 92.5263 268.627 90.689V67.2632H259.63V56.5455H285V92.3732C285 101.458 285 106 285 106H249.014C237.859 106 232.281 101.458 232.281 92.3732V23.4737C232.281 14.4912 237.859 10 249.014 10H268.267C279.422 10 285 14.4912 285 23.4737V38.0191Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1585_10985",
    x: 0,
    y: 0,
    width: 295,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1585_10985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1585_10985",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubigWhiteLogo);
export default __webpack_public_path__ + "static/media/KubigWhiteLogo.c9ac397ad32394b4886d1b1430fb2dbe.svg";
export { ForwardRef as ReactComponent };